import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as Groups from 'groups/components';
import GroupFormHandlers from 'groups/containers/GroupFormHandlers';

import { getIsSaving, getIsFetching, getEditing, getIsFetchingConfig } from 'groups/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors';

class GroupsFormContainer extends Component {
  render = () => (
    <GroupFormHandlers
      render={({
        handleSubmit,
        handleValidation,
        handleValueChange,
        handleCustomCheck,
        isSubmitted,
        isSaving,
      }) => (
        <Groups.FormView
          company={this.props.company}
          group={this.props.group}
          customs={this.props.customs}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          handleCustomCheck={handleCustomCheck}
          isFetching={this.props.isFetching}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          subcompany={this.props.subcompany}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  group: getEditing(state),
  customs: getVisibleCustomFieldsEmployees(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(GroupsFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/containers/GroupFormContainer.js